import { lockBodyScroll, unlockBodyScroll } from "./utils.js";
import { INTENT, STATE, dispatch, on } from "./ui-events.js";

const SELECTORS = {
  panel: "[data-mnd-panel]",
  overlay: "[data-mnd-overlay]",
  closeBtn: "[data-mnd-close]",
};

class MobileNavDrawer extends HTMLElement {
  #callbackFunctions = [];

  constructor() {
    super();
    this.onKeydown = this.onKeydown.bind(this);
  }

  connectedCallback() {
    try {
      this.init();
    } catch (error) {
      console.error("[MobileNavDrawer:init]", error);
    }
  }

  init() {
    this.#bindElements();
    this.#validateElements();
    this.#bindEvents();

    if (this.dataset.mndShowInEditor === "true") {
      this.open();
    }
  }

  #bindElements() {
    this.panel = this.querySelector(SELECTORS.panel);
    this.overlay = this.querySelector(SELECTORS.overlay);
    this.closeBtn = this.querySelector(SELECTORS.closeBtn);
  }

  #validateElements() {
    if (!this.panel) throw new Error("[MobileNavDrawer] Missing [data-mnd-panel]");
    if (!this.overlay) throw new Error("[MobileNavDrawer] Missing [data-mnd-overlay]");
    if (!this.closeBtn) throw new Error("[MobileNavDrawer] Missing [data-mnd-close]");
  }

  #bindEvents() {
    this.closeBtn.addEventListener("click", this.#onCloseBtnClick.bind(this));
    this.overlay.addEventListener("click", this.#onOverlayClick.bind(this));
    this.#callbackFunctions.push(
      on(INTENT.NAV_OPEN, () => this.open()),
      on(INTENT.NAV_CLOSE, () => this.close()),
    );
  }

  open() {
    this.removeAttribute("hidden");
    this.style.pointerEvents = "auto";

    requestAnimationFrame(() => {
      this.classList.add("is-open");
    });

    this.panel.focus();
    document.addEventListener("keydown", this.onKeydown);
    if (!Shopify?.designMode) lockBodyScroll();
  }

  close() {
    this.classList.remove("is-open");
    this.style.pointerEvents = "none";
    document.removeEventListener("keydown", this.onKeydown);

    this.panel.addEventListener(
      "transitionend",
      () => {
        if (!this.classList.contains("is-open")) {
          this.setAttribute("hidden", "");
        }
      },
      { once: true },
    );

    dispatch(STATE.NAV_CLOSED);
    if (!Shopify?.designMode) unlockBodyScroll();
  }

  onKeydown(event) {
    if (event.key === "Escape" && this.classList.contains("is-open")) {
      this.close();
    }
  }

  #onCloseBtnClick() {
    this.close();
  }

  #onOverlayClick() {
    this.close();
  }

  disconnectedCallback() {
    this.#cleanup();
  }

  #cleanup() {
    this.#callbackFunctions.forEach((fn) => fn());
    this.#callbackFunctions = [];
    document.removeEventListener("keydown", this.onKeydown);
  }
}

if (!customElements.get("mobile-nav-drawer")) {
  customElements.define("mobile-nav-drawer", MobileNavDrawer);
}
